import {LiveReducer, ReducerFromState} from "../../../@types/reducers";

export const getLivesLength = (state: ReducerFromState<LiveReducer>): number => state.live.alerts.length;
